import React, { useCallback, useState } from 'react'

import { Button, Panel } from 'rsuite'
import { Link, generatePath } from 'react-router-dom'
import LegacyListIcon from '@rsuite/icons/legacy/List'

import { ROUTE_BUSINESS_PROFILES, ROUTE_CATALOG_PRODUCT_REVIEWS } from '@@partner:config/routes'
import BusinessProfilesTable from './grid/BusinessProfilesTable'
import { useFetchAllBusinessProfiles } from '@@partner:graphql/query/businessProfiles/allBusinessProfiles.gql'
import { SORT_ORDER_DESC } from '@@partner:config/graphql'
import { CommonSort } from '@@partner:types:graphql'
import { BusinessProfile, RsuiteSortType } from '@@partner:types:app'

export interface ModerationCompleteInfoProps {
  brandSlug: string
  filter: {}
}

export default function ModerationCompleteInfo ({
  brandSlug,
  filter
}: ModerationCompleteInfoProps) {
  const [ page, setPage ] = useState(1)
  const [ sort, setSort ] = useState<CommonSort>({
    fieldName: 'id',
    direction: 0
  })

  const { data, loading, refetch } = useFetchAllBusinessProfiles({
    filter,
    sort,
    pager: {
      limit: 24,
      page
    }
  })

  const handleSortColumn = useCallback((sortColumn: string, sortType: RsuiteSortType | undefined) => {
    setSort({
      fieldName: sortColumn,
      direction: sortType === 'desc' ? 0 : 1
    })
  }, [])

  if (!data?.allBusinessProfiles.edges) {
    return null
  }


  return (
    <div className="flex flex-col">
      <Button
        color="green"
        size="sm"
        appearance="primary"
        as={Link}
        to={generatePath(ROUTE_BUSINESS_PROFILES, {
          brandSlug
        })}
        className="w-1/6 mb-4"
      >
        <LegacyListIcon /> Компании
      </Button>
      <h1 className="text-2xl font-bold sm:text-3xl sm:tracking-tight">
        История этой сессии:
      </h1>
      <Panel className="mt-4">
        <BusinessProfilesTable 
          businessProfiles={data?.allBusinessProfiles.edges} 
          brandSlug={brandSlug} 
          loading={loading}
          onSortColumn={handleSortColumn}
          sortColumn={sort.fieldName}
          sortType={sort.direction === 0 ? 'desc' : 'asc'}
        />
      </Panel>
    </div>
  )
}
